import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'presentation/redux/hooks';
import { commonHelpers } from 'utilities/helpers';
import { COMMON } from 'utilities/constants/COMMON';
import { CountLike } from '../../CU-002-01/components/CountLike';
import { RateBadge } from '../../CU-002-01/components/Rate';

interface props {
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
    countLike?: number;
    isBookmarked: boolean;
    onClickBookmark: () => void;
}
export const MarketPrice = ({
    detailAssessment,
    countLike,
    isBookmarked,
    onClickBookmark,
}: props) => {
    const userSlice = useAppSelector((state) => state.user);
    const navigate = useNavigate();
    const { listedPropertyId } = useParams();
    return (
        <section>
            <div
                className="center-inside row"
                style={{ height: 24, width: 'fit-content', marginTop: 16 }}
            >
                <section className="like-lable cell">{detailAssessment?.name}</section>
                <section className="cell"
                         style={{ fontSize: '20px'}}>
                </section>
                <section
                    className="cell"
                    style={{ textAlign: 'right', marginRight: 8, cursor: 'pointer' }}
                    onClick={onClickBookmark}
                >
                    <CountLike value={countLike} currentBookmarked={isBookmarked} />
                </section>
            </div>
            <div
                className="center-inside row"
                style={{ height: 24, width: 'fit-content', marginTop: 16 }}
            >
                <section className="mkp-label cell">即決価格</section>
                <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                    <span className="mkp-number">
                        {commonHelpers
                            .roundTenThousandYen(detailAssessment?.askingSalePriceUpperLimit)
                            .toLocaleString('en-US', {
                                maximumFractionDigits: 2,
                            })}
                    </span>
                    <span className="mkp-unit"> 万円</span>
                </section>
                <RateBadge value={detailAssessment?.rateBuyNow} fill="#ffffff" />
            </div>
                <>
                    <div
                        className="center-inside row"
                        style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                    >
                        <section className="mkp-label cell">現在の最高入札額</section>
                        <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                            <span className="mkp-number">
                                {commonHelpers
                                    .roundTenThousandYen(
                                        detailAssessment?.currentHighestAuctionPrice,
                                    )
                                    .toLocaleString('en-US', {
                                        maximumFractionDigits: 2,
                                    })}
                            </span>
                            <span className="mkp-unit"> 万円</span>
                        </section>
                        <RateBadge
                            value={
                                detailAssessment?.currentHighestAuctionPrice
                                    ? detailAssessment?.rateHighestAuctionNow
                                    : 0
                            }
                            fill="#ffffff"
                        />
                    </div>
                    {detailAssessment?.isLogin && detailAssessment?.yourAuctionBid && (
                        <div
                            className="center-inside row"
                            style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                        >
                            <section className="mkp-label cell">あなたの入札額</section>
                            <section
                                className="cell"
                                style={{
                                    textAlign: 'right',
                                    marginRight: 8,
                                    display: 'table-cell',
                                }}
                            >
                                <span className="mkp-number">
                                    {commonHelpers
                                        .roundTenThousandYen(detailAssessment?.yourAuctionBid)
                                        .toLocaleString('en-US', {
                                            maximumFractionDigits: 2,
                                        })}
                                </span>
                                <span className="mkp-unit"> 万円</span>
                            </section>
                            <RateBadge
                                value={detailAssessment?.rateYourAuctionBids}
                                fill="#ffffff"
                            />
                        </div>
                    )}
                </>
            {(!userSlice.isSignedIn && (
                <section>
                    <p>※ 最低落札価格が設定されています。</p>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '50%' }}>
                            <p style={{ textAlign: 'center' }}>
                                シミュレーションは登録不要でご利用いただけます。
                            </p>
                            <div className="form-button simulate-form-button"
                                onClick={() =>
                                    !detailAssessment?.isLogin
                                        ? navigate(
                                              `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_01}/${listedPropertyId}`,
                                          )
                                        : null
                                }
                            >
                                シミュレーションへ
                            </div>
                        </div>
                        <div style={{ width: '50%' }}>
                            <p style={{ textAlign: 'center' }}>
                                もっと知りたい方はログインが必要です。
                            </p>
                            <div
                                className="form-button login-form-button"
                                onClick={() =>
                                    navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`)
                                }
                            >
                                ログイン・アカウント作成へ
                            </div>
                        </div>
                    </div>
                </section>
            )) || <section style={{ borderBottom: '1px solid', marginTop: 20 }}></section>}
        </section>
    );
};
